// Helpers de matching entre JSON Pointers usando la semántica de PREFIJO
// que aplica el back (mismo criterio que `allowedFields`).
//
// - `isPrefixOverlap(a, b)`: dos pointers se solapan si son iguales O si uno
//   es prefijo del otro (con separador `/` para no matchear `/nameField`
//   contra `/name`).
// - `isPointerCoveredByAllowedFields(pointer, allowedFields)`: peer explícito
//   del back: `k === a || k.startsWith(a + '/')`. Un ANCESTRO en allowedFields
//   cubre al pointer. Ej: `/attributes/pricing` cubre `/attributes/pricing/basePrice`.
//   Con `/` boundary — `/attributes/pricingRules` NO está cubierto por `/attributes/pricing`.
//   `allowedFields` vacío = área sin restricción (paint todo).

export function isPrefixOverlap(a: string, b: string): boolean {
  if (a === b) return true;
  return a.startsWith(`${b}/`) || b.startsWith(`${a}/`);
}

export function isPointerCoveredByAllowedFields(
  pointer: string,
  allowedFields: readonly string[] | null | undefined,
): boolean {
  // Vacío/ausente = sin restricción de scope.
  if (!allowedFields || allowedFields.length === 0) return true;
  return allowedFields.some(
    (a) => pointer === a || pointer.startsWith(`${a}/`),
  );
}

// Normaliza dot-form (`attributes.pricing`) a JSON pointer (`/attributes/pricing`).
// El back normaliza en ambos lados antes de comparar; un config legacy escrito
// via SQL directo o pre-normalización puede tener cualquiera de las dos formas.
// El editor debe normalizar antes de validar scope o rechaza configs válidos.
export function normalizePointer(input: string): string {
  if (input.startsWith('/')) return input;
  return `/${input.replace(/\./g, '/')}`;
}
